import { SdkError } from '@yandex-video-platform/goloom-sdk';

export interface ConferenceConfigOptions {
    roomId: string;
    searchString?: string;
    displayName?: string;
}

export enum TelemostBackendErrorCode {
    /** Неизвестная проблема */
    UNKNOWN = 'TIE-0000',
    /** Конференция не найдена */
    CONFERENCE_NOT_FOUND = 'TIE-0001',
    /** Пир не найден */
    PEER_NOT_FOUND = 'TIE-0002',
    /** Сессия не найдена */
    SESSION_NOT_FOUND = 'TIE-0003',
    /** Пользователь забанен */
    BAN = 'TIE-1000',
    /** Пользователь кикнут */
    KICK = 'TIE-1001',
    /** Конференция переполнена */
    CONFERENCE_OVERFLOW = 'TIE-1002',
    /** Некорректные креды на вход */
    INCORRECT_CREDENTIALS = 'TIE-0004',
    /** Протухли креды на вход */
    CREDENTIALS_EXPIRED = 'TIE-0005',
}

export interface GoloomSdkError {
    error: SdkError;
}

export enum MeanOpinionScore {
    POOR = 'poor',
    GOOD = 'good',
    EXCELLENT = 'excellent',
}
